import Handle from 'rc-slider/lib/Handle';

export default Handle;
